import classnames from 'classnames';
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react'; // eslint-disable-line no-unused-vars
import {isEqual} from 'lodash';

import ListEditor from './listField/ListEditor';
import ListViewer from './listField/ListViewer';

import './ListField.scss';

@inject('personaStore', 'templateStore')
@observer
export default class ListField extends Component {
  state = {
    editing: false
  }

  editMode = () => {
    if (!this.props.personaStore.isEditable)
      return;
    this.setState({editing: true});
  }

  viewMode = () => {
    this.setState({editing: false});
  }

  // We are only updating these lists on blur
  // We are updating from the store
  onListChange = (value) => {
    const {formKey, templateStore} = this.props;
    const {selectedTemplate} = templateStore;
    if (!isEqual(value, selectedTemplate[formKey]) && value.length > 0) {
      const {body, updateBody} = this.props.personaStore;
      const updatedBody = Object.assign({}, body);
      updatedBody[this.props.formKey] = value;
      updateBody(updatedBody);
    }
    this.viewMode();
  }

  render() {
    const {editing} = this.state;
    const {formKey, personaStore, templateStore} = this.props;
    const {body, isEditable} = personaStore;
    const label = formKey.replace('_', ' ').toLowerCase();
    const value = body[formKey] ? body[formKey] : templateStore.selectedTemplate[formKey];
    const fieldClasses = classnames([
      'col-md-6',
      'persona-section_spacing',
      {
        'editable': isEditable,
      }
    ]);

    return (
      <div className={fieldClasses} onClick={this.editMode}>
        <div className="list-label">{label}</div>
        {editing && <ListEditor value={value} onChange={this.onListChange} onBlur={this.onListChange} {...this.props}/>}
        {!editing && <ListViewer value={value} {...this.props}/>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/ListField.jsx